import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'nc-secondary-toolbar',
  templateUrl: './secondary-toolbar.component.html',
  styleUrls: ['./secondary-toolbar.component.scss']
})
export class SecondaryToolbarComponent implements OnInit {

  @Input() current: string;
  @Input() crumbs: string[];

  // constructor(
  //   public translate: TranslateService) { 
  //     const browserLang = localStorage.getItem('lang');  
  //     translate.use(browserLang); 
  //   }
  
  constructor(){}

  ngOnInit() {
  }
}
